module.exports = __webpack_public_path__ + "static/assets/754c9f67512f29d9f799744146cc38ee.svg";